import styled from 'styled-components';
import { gridColumnGap, GridProps } from 'styled-system';

export const NameWrapper = styled.div<GridProps>`
  display: flex;
  align-items: center;
  ${gridColumnGap};
`;
